import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";

@Component({
    selector: "app-container",
    standalone: true,
    template: `
        <section class="base-container">
            <ng-content />
        </section>
    `,
    styleUrls: ["./container.component.scss"],
    imports: [CommonModule],
})
export class Container {}
